module.exports = __webpack_public_path__ + "static/media/3.6cd6edd7.jpeg";